/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Filter_OpenInputs */

const cs_tasks_filter_open = /** @type {(inputs: Tasks_Filter_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřené`)
};

const en_tasks_filter_open = /** @type {(inputs: Tasks_Filter_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

/**
* | output |
* | --- |
* | "Open" |
*
* @param {Tasks_Filter_OpenInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_filter_open = /** @type {((inputs?: Tasks_Filter_OpenInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Filter_OpenInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_filter_open(inputs)
	return cs_tasks_filter_open(inputs)
});